import React, { Component } from "react";
import { Translate } from "react-redux-i18n";

export default class ChatSoonModal extends Component {

    render() {
        return <div className="modal fade text-center" id="chat-soon-modal" tabIndex="-1" role="dialog" aria-labelledby="chat-soon-modal" aria-hidden="true">
            <div className="modal-dialog modal-dialog-centered" role="document">
                <div className="modal-content">
                    <div className="modal-body">
                        <h4 id="chat-description" style={{ marginBottom: "0px" }}><Translate value="modals.chatSoon.title" /></h4>
                    </div>
                </div>
            </div>
        </div>;
    }
}